import React, { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

import { Theme } from '@app/theme';
import { Trans } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  indexContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase * 4,
  },
  img: {
    height: theme.marginBase * 9,
    width: theme.marginBase * 9,
  },
  description: {
    ...theme.fonts.caption,
  },
}));

interface Props {
  text: ReactNode;
  img: string;
}

export const RulesIndexBox = ({ text, img }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.indexContainer}>
      <img src={img} alt="search" className={classes.img} />
      <p className={classes.description}>{text}</p>
    </div>
  );
};
